import React, { useState, useEffect } from "react";
import { useAuth } from "../../context/AuthContext";
import API from "../../services/api";
import EditUserForm from "../../components/User/EditUserForm";
import EditAddressForm from "../../components/User/EditAddressForm"; 
import { t } from "@lingui/macro";

const Account = () => {
    const { userEmail } = useAuth();
    const [userData, setUserData] = useState(null);
    const [userAddress, setUserAddress] = useState(null);
    const [isEditingUser, setIsEditingUser] = useState(false);
    const [isEditingAddress, setIsEditingAddress] = useState(false);
  
    useEffect(() => {
      if (userEmail) {
        API.get(`/api/users/me`)
          .then((response) => setUserData(response.data))
          .catch((error) => console.error("Error fetching user data:", error));
  
        API.get(`/api/users/address`)
          .then((response) => setUserAddress(response.data))
          .catch((error) => console.error("Error fetching address:", error));
      }
    }, [userEmail]);
  
    const handleSaveUser = (updatedUser) => {
      API.put(`/api/users/${userEmail}`, updatedUser)
        .then((response) => {
          setUserData(response.data);
          setIsEditingUser(false);
        })
        .catch((error) => console.error("Error updating user data:", error));
    };
  
    const handleSaveAddress = (updatedAddress) => {
      API.put(`/api/users/address`, updatedAddress)
        .then((response) => {
          setUserAddress(response.data); 
          setIsEditingAddress(false);  
        })
        .catch((error) => console.error("Error updating address:", error));
    };
  
    if (!userData) return <div>Loading user data...</div>;
  
    return (
      <div className="account-container">
        <div className="account-content">
          <div className="user-section">
            {!isEditingUser ? (
              <>
                <h2>{t`My Account`}</h2>
                <div className="user-info">
                  <p><strong>{t`Email`}:</strong> {userData.email}</p>
                  <p><strong>{t`First Name`}:</strong> {userData.firstName}</p>
                  <p><strong>{t`Last Name`}:</strong> {userData.lastName}</p>
                  <p><strong>{t`Phone`}:</strong> {userData.phoneNumber}</p>
                </div>
                <button className="add-new-btn" onClick={() => setIsEditingUser(true)}>{t`Update Data`}</button>
              </>
            ) : (
              <EditUserForm user={userData} onSave={handleSaveUser} onCancel={() => setIsEditingUser(false)} />
            )}
          </div>
  
          <div className="address-section">
            {!isEditingAddress ? (
              <>
                <h2>{t`Address`}</h2>
                {userAddress ? (
                  <div className="address-info">
                    <p><strong>{`Street`}:</strong> {userAddress.address1}</p>
                    {userAddress.address2 && <p><strong>{t`Address`} 2:</strong> {userAddress.address2}</p>}
                    <p><strong>{t`City`}:</strong> {userAddress.city}</p>
                    <p><strong>{t`State`}:</strong> {userAddress.state}</p>
                    <p><strong>{t`Zip Code`}:</strong> {userAddress.zipCode}</p>
                    <p><strong>{t`Country`}:</strong> {userAddress.country}</p>
                  </div>
                ) : (
                  <p>{t`No address.`}</p>
                )}
                <button className="add-new-btn" onClick={() => setIsEditingAddress(true)}>{t`Update Address`}</button>
              </>
            ) : (
              <EditAddressForm address={userAddress} onSave={handleSaveAddress} onCancel={() => setIsEditingAddress(false)} />
            )}
          </div>
        </div>
      </div>
    );
  };
  
  export default Account;
  